// extracted by mini-css-extract-plugin
module.exports = {"svg":"Ring_svg__1tjaq","spin":"Ring_spin__mdZfG","ring":"Ring_ring__3hzhj","ball":"Ring_ball__2yPUs"};